import { render, staticRenderFns } from "./VerticalAligned.vue?vue&type=template&id=383780d5&scoped=true&"
import script from "./VerticalAligned.vue?vue&type=script&lang=ts&"
export * from "./VerticalAligned.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383780d5",
  null
  
)

export default component.exports